import { ApiGroup } from '../types/ApiTypes';

export const PointTransactionAPI: ApiGroup = {
    pagedList: {
        title: '포인트 거래 내역 조회',
        method: 'POST',
        url: '/PointTransaction/PagedList',
        paramz: {},
    },
    grantPoint: {
        title: '포인트 지급',
        method: 'POST',
        url: '/PointTransaction/GrantPoint', // Endpoint we expect to exist (or will exist)
        paramz: {},
    },
};
